import useStoreAuth from './useStoreAuth.js';

/**
 * Returns the auth token info.
 */
export const useAuth = () => {
  const [auth] = useStoreAuth();

  if (auth.token) {
    return auth;
  }

  return null;
};

export default useAuth;
